// this is going to be global contract in the lib
import { Event } from "../../contracts";
import { eBranches } from "sb-resp-lib";
import { Scoreboards } from "../../constants/Scoreboards";

export const mapGameScore = (x: Event): Event => {
    const emptyScore = {
        homeScore: "",
        awayScore: "",
        additionalScores: {},
        combinedSecondTierScores: []
    };
    x.score = { ...emptyScore, ...x.score };

    x.scoreboard = Scoreboards[eBranches[x.sportId]] && { ...Scoreboards.Empty(), ...Scoreboards[eBranches[x.sportId]](x) };
    return x;
}
